module.exports = __webpack_public_path__ + "images/emoji/bow.706c24b9f8fa06cead3b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bow.png
// module id = p5xP
// module chunks = 2